
<template>
    <router-view/>
</template>
 
<script>
    export default {
        name: "ForRouter"
    }
</script>
 
<style scoped>
 
</style>